import { emitNotification } from "@impero-com/ui";
import * as Sentry from "@sentry/react";

import { useLegacyControlCreateControlResultPreview } from "api/legacy/legacy-control/legacy-control";

export const useLegacyControlPreviewMutation = () =>
    useLegacyControlCreateControlResultPreview({
        mutation: {
            onError: (error) => {
                Sentry.captureException(error);
                emitNotification("error", error.message);
            },
        },
    });
